module.exports = __webpack_public_path__ + "static/media/brawl-stars_sandy3.03a5b5a2.png";